{{machineName}}

<div *ngFor="let instrument of instruments">
    {{instrument.id}}
    {{instrument.instrumentName}}
    {{instrument.location}}
    {{instrument.cName}}
</div>